
const messages = {
    pt: {
        translations: {
            titles: {
                app: 'Minha Aplicação'
            },
            messages: {
                itWorks: 'Está funcionando com vários idiomas.',
                smallText: 'Um pequeno texto',
            },
            buttons: {
                save: 'Salvar'
            }
        }
    }
}


export { messages };
